import {Action, Module, Mutation} from 'vuex-module-decorators'
import {MdbsCore} from "@/api/tsclient";
import store, {alertModule} from "@/store";
import BaseModule from "@/store/modules/BaseModule";
import RightDto = MdbsCore.RightDto;
import RightCreateDto = MdbsCore.RightCreateDto;
import RightUpdateDto = MdbsCore.RightUpdateDto;

const rightClient = new MdbsCore.RightClient();

@Module({namespaced: true, name: "rights", store: store})
export default class RightsModule extends BaseModule {
    rights: Array<RightDto> = [];

    get rightsForCurrentUser() {
        return rightClient.getAllRightsForCurrentUser();
    }

    @Mutation
    setRights(rights: Array<RightDto>) {
        this.rights.updateValues(rights);
    }

    @Mutation
    resetRights() {
        this.rights.clear();
    }

    @Action({rawError: true})
    async loadAll() {
        this.startLoading();
        try {
            this.context.commit('setRights', await rightClient.getAllRights(false))
        } catch (e) {
            console.error("rights: loadall", e);
            this.context.commit('resetRights')
            await alertModule.handleException(e);
        } finally {
            this.stopLoading();
        }
    }

    @Action({rawError: true})
    async createRight(rightDto: RightCreateDto) {
        this.startLoading();
        try {
            await rightClient.create(rightDto)
            await this.loadAll()
        } catch (e) {
            console.error("right: create", e);
            await alertModule.handleException(e);
        } finally {
            this.stopLoading();
        }
    }

    @Action({rawError: true})
    async getRightById(rightId: string) {
        try {
            return rightClient.findRight(rightId)
        } catch (e) {
            console.error("right: get by id", e);
            await alertModule.handleException(e);
        }
        return null;
    }

    @Action({rawError: true})
    async getRightByName(rightName: string) {
        try {
            return rightClient.findRightByName(rightName)
        } catch (e) {
            console.error("right: get by name", e);
            await alertModule.handleException(e);
        }
        return null;
    }

    @Action({rawError: true})
    async updateRight(rightDto: RightUpdateDto) {
        this.startLoading();
        try {
            await rightClient.update(rightDto.id, rightDto)
            await this.loadAll()
        } catch (e) {
            console.error("right: update", e);
            await alertModule.handleException(e);
        } finally {
            this.stopLoading();
        }
    }
}
